export default {
  'Start at': 'ابدأ من',
  'Set to current time': 'الضبط على الوقت الحالي',
  'Audio volume': 'مستوى الصوت',
  'Video volume': 'مستوى صوت مقاطع الفيديو',
  'Trim audio': 'اقتطاع مقاطع الصوت',
  'Audio will end with the video': 'سينتهي الصوت مع الفيديو',
  'Trim': 'اقتطاع ',
}